var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquarecheckboxsolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4652_90057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 3.33203C1.33337 2.22746 2.2288 1.33203 3.33337 1.33203H12.6667C13.7713 1.33203 14.6667 2.22746 14.6667 3.33203V12.6654C14.6667 13.7699 13.7713 14.6654 12.6667 14.6654H3.33337C2.2288 14.6654 1.33337 13.7699 1.33337 12.6654V3.33203Z",
    stroke: "#666E7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2761 5.52734C11.5365 5.78769 11.5365 6.2098 11.2761 6.47015L7.13807 10.8035C6.87772 11.0638 6.45561 11.0638 6.19526 10.8035L4.19526 8.80349C3.93491 8.54314 3.93491 8.12103 4.19526 7.86068C4.45561 7.60033 4.87772 7.60033 5.13807 7.86068L6.66667 9.38927L10.3333 5.52734C10.5937 5.26699 11.0158 5.26699 11.2761 5.52734Z",
    fill: "#666E7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4652_90057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarecheckboxsolid);
export default __webpack_public_path__ + "static/media/square checkbox solid.184afd09f641c86f6d39647e841c7bfa.svg";
export { ForwardRef as ReactComponent };